// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { ZoneAssociation_abstract } from './../abstract/SagaBase/ZoneAssociation_abstract';
export class ZoneAssociation extends ZoneAssociation_abstract {}
